import {Component, OnInit, ViewChild} from '@angular/core';
import { WebsocketService } from "../../services/websocket/websocket.service";
import { SnotifyService } from 'ng-snotify'
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import { DetalhesModalComponent } from "./detalhes-modal/detalhes-modal.component";
import { HamiltonService } from "../../services/hamilton/hamilton.service";

@Component({
    selector: 'app-monitor-falhas',
    templateUrl: './monitor-clientes.component.html',
    styleUrls: ['./monitor-clientes.compoment.scss'],
})
export class MonitorClientesComponent implements OnInit {

    @ViewChild('monitorDetalhesModal') monitorDetalhesModal: DetalhesModalComponent

    public loading = false;

    public fullScreen = false;

    public clientes = [];

    public formFilter = new FormGroup({
        client_id: new FormControl('', []),
        application: new FormControl('', []),
        sub_application: new FormControl('', []),
        module: new FormControl('', []),
    });

    public appNomes = [
        {id: 1, text: 'NFE'},
        {id: 2, text: 'CTE'},
        {id: 3, text: 'NFSE'},
        {id: 4, text: 'MDFE'},
        {id: 5, text: 'NFCE'},
        {id: 6, text: 'CONCESSIONARIA'},
        {id: 7, text: 'PORTAL'},
        {id: 8, text: 'GNRE'},
        {id: 9, text: 'GESTAO_DESEMPENHO'}
    ]

    constructor(
        private websocket: WebsocketService,
        private _notify: SnotifyService,
        private hamiltonService: HamiltonService
    ) {
    }

    ngOnInit() {
        this._listenEvents();
        this._getClientes();
    }

    openDetalhes(reportData, clientData) {
        if(this.monitorDetalhesModal.setDataModal(reportData, clientData)) {
            this.monitorDetalhesModal.isVisible = true;
        } else {
            this._notify.error('Não foi possivel carregar os detalhes')
        }
    }

    toggleFullScreen() {
        this.fullScreen = !this.fullScreen
    }

    private _listenEvents(): void {
        this.websocket.listen('hamilton_notification_general', 'Hamilton\\Open\\Report', (data) => {
            switch(data.type) {
                case 'open_report' :
                    this._novoReport(data.data)
                    break
            }
        });
    }

    private _novoReport(data) {
        let client = this.clientes.find((client) => client.id == data.client_id);

        if(client)
        {
            let msgNotify = client.name + ' - Erro código: ' + data.code;
            let reportIndex = client.reports.findIndex((report) => report.id == data.id);

            if(reportIndex >= 0)
            {
                client.reports.splice(reportIndex, 1);
            }

            client.reports.unshift(data);

            this._notify.warning(msgNotify,'Nova ocorrência', {
                closeOnClick: true,
                timeout: 0,
                showProgressBar: false,
                buttons: [{
                    text: 'Detalhes',
                    bold: false,
                    action: () => {
                        this.openDetalhes(data, {id: client.id, name: client.name})
                    }
                }]
            });

            this._playAudio();
        }
    }

    private _getAppName(id: number): string {
        return this.appNomes.find(app => app.id == id) != undefined ? this.appNomes.find(app => app.id == id).text : 'N/A';
    }

    private _getClientes() {
        this.hamiltonService.getClients().subscribe((data) => {
            this.clientes = data.data.clientes.map((client) => {
                client.reports = [];
                this.hamiltonService.getReportByClient(client.id).subscribe((data) => {
                    client.reports = data.data.reports
                }, error => {
                    this._notify.error(`Falha ao consultar ocorrências de ${client.name}`)
                })
                return client;
            });
        }, error => {
            this._notify.error('Falha ao consultar os clientes')
        })
    }

    /**
     * Trunca o texto.
     * @param text
     */
    public shortDescription(text) {
        if(text != null)
            return text.substring(0,50);
    }

    /**
     * Responsavel por tocar áudio de notificação
     * @private
     */
    private _playAudio(){
        let audio = new Audio();
        audio.src = "../assets/sounds/novo-report.wav";
        audio.load();
        audio.play();
    }

    public removeReport(data) {
        let client = this.clientes.find((client) => client.id == data.client_id);

        if(client)
        {
            let reportIndex = client.reports.findIndex((report) => report.id == data.report_id);

            if(reportIndex >= 0)
            {
                client.reports.splice(reportIndex, 1);
            }
        }
    }

    public filter(clients) {

        let filtereds = JSON.parse(JSON.stringify(clients)).filter((client) => {

            if(this.formFilter.get('client_id').value
                && client.id != this.formFilter.get('client_id').value)
                return false

            return true
        })

        filtereds.forEach(client => {

            client.reports = client.reports.filter(report => {

                if(this.formFilter.get('application').value
                    && report.application != this.formFilter.get('application').value)
                    return false

                if(this.formFilter.get('sub_application').value
                    && report.sub_application != this.formFilter.get('sub_application').value)
                    return false

                if(this.formFilter.get('module').value
                    && report.module != this.formFilter.get('module').value)
                    return false

                return true
            })
        })

        return filtereds;
    }
}
